
















import { Vue, Component, Prop } from "vue-property-decorator";
import CategoryChip from "./CategoryChip.vue";

@Component({
  components: {
    CategoryChip
  }
})
export default class SelectionsTooltipButton extends Vue {
  @Prop({ type: Array, default: () => [] })
  selections!: string[];
}
